import { render, staticRenderFns } from "./addproducttoken.vue?vue&type=template&id=1d28c734&"
import script from "./addproducttoken.vue?vue&type=script&lang=js&"
export * from "./addproducttoken.vue?vue&type=script&lang=js&"
import style0 from "./addproducttoken.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports